export const mapShapeToState = (shape, offset = 0) => {
  const children = [];
  if (shape.children.length) {
    for (const child of shape.children) {
      const mappedChild = mapShapeToState(child, offset)
      children.push(mappedChild)
    }
  }
  const attrs = JSON.parse(JSON.stringify(shape.attrs))
  attrs.anchors =  shape.attrs.anchors;
  if (offset && attrs.x !== undefined) {
    attrs.x = attrs.x + offset;
    attrs.y = attrs.y + offset;
  }
  return { attrs: attrs, type: shape.attrs.shapeType, children: children }
}



// WEBPACK FOOTER //
// ./src/components/schemaFonctionnel/helper/mapShapeToState.js